import { cn } from '@/lib/utils'
import { Card } from '@/components/ui/card'
import type { Metric } from '../../types'

interface KeyMetricsGridProps {
  metrics: Metric[]
}

export function KeyMetricsGrid({ metrics }: KeyMetricsGridProps) {
  if (metrics.length === 0) return null

  return (
    <Card className="bg-card border border-border rounded-2xl p-4">
      <p className="text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground mb-3">
        Métricas-Chave
      </p>
      <div className="grid grid-cols-2 gap-3">
        {metrics.map((m) => (
          <div key={m.key} className="bg-muted/30 rounded-xl p-3 flex flex-col gap-1">
            <span className="text-[10px] text-muted-foreground uppercase tracking-[0.06em]">
              {m.label}
            </span>
            <span
              className={cn(
                'text-lg font-bold tabular-nums font-mono tracking-[-0.02em]',
                m.status === 'success' && 'text-success',
                m.status === 'warning' && 'text-warning',
                m.status === 'danger' && 'text-destructive',
                (m.status === 'accent' || !m.status) && 'text-primary',
              )}
            >
              {m.formattedValue}
            </span>
          </div>
        ))}
      </div>
    </Card>
  )
}
